var EntityKind;
(function (EntityKind) {
    EntityKind["DEMANDE_FINANCEMENT"] = "DEMANDE_FINANCEMENT";
    EntityKind["TIERS"] = "TIERS";
    EntityKind["TELESERVICE"] = "TELESERVICE";
    EntityKind["DEMANDE_APPRENANT"] = "DEMANDE_APPRENANT";
    EntityKind["DEMANDE_COMPLEMENT_PIECES"] = "DEMANDE_COMPLEMENT_PIECES";
    EntityKind["DEMANDE_PAIEMENT"] = "DEMANDE_PAIEMENT";
    EntityKind["SOLLICITATIONS"] = "SOLLICITATIONS";
    EntityKind["CONTRIBUTIONS"] = "CONTRIBUTIONS";
    EntityKind["OIDC_PROVIDER"] = "OIDC_PROVIDER";
    EntityKind["NO_BUSINESS_ENTITY"] = "NO_BUSINESS_ENTITY";
    EntityKind["MASTER_DATA"] = "MASTER_DATA";
    EntityKind["DOCUMENT"] = "DOCUMENT";
})(EntityKind || (EntityKind = {}));
var ErrorKind;
(function (ErrorKind) {
    ErrorKind["NOT_FOUND"] = "NOT_FOUND";
    ErrorKind["BUSINESS"] = "BUSINESS";
    ErrorKind["TECHNICAL_ERROR"] = "TECHNICAL_ERROR";
})(ErrorKind || (ErrorKind = {}));
class BusinessError extends Error {
    kind;
    details;
    type;
    entity;
    constructor(kind, details) {
        super(details.message ?? `${kind} error on ${details.entity}`);
        this.kind = kind;
        this.details = details;
        this.type = kind;
        this.entity = details.entity;
    }
}
function buildBusinessErrorFromError(error, { kind = ErrorKind.TECHNICAL_ERROR, entityKind = EntityKind.NO_BUSINESS_ENTITY, } = {}) {
    if (error instanceof Error) {
        return new BusinessError(kind, { entity: entityKind, message: error.message });
    }
    else {
        throw error;
    }
}
export { BusinessError, EntityKind, ErrorKind, buildBusinessErrorFromError };
//# sourceMappingURL=business-error.js.map